export default "__VITE_ASSET__b368b0b2__"